import { LanguageType } from "@/types/enums";
import { createSlice } from "@reduxjs/toolkit";

type Language = { id: number; name: string; lang: LanguageType }[];

export const languagesData: Language = [
  { id: 1, name: "繁體中文", lang: LanguageType.ZH_HK },
  { id: 2, name: "简体中文", lang: LanguageType.ZH_CN },
  { id: 3, name: "English", lang: LanguageType.EN },
  { id: 4, name: "العربية", lang: LanguageType.AR },
  { id: 5, name: "Español", lang: LanguageType.ES },
  { id: 6, name: "Français", lang: LanguageType.FR },
  { id: 7, name: "Português", lang: LanguageType.PT },
];

const initialState = {
  dynamicColor: {
    primary: "#000000",
    secondary: "#000000",
  },
};

const settingsSlice = createSlice({
  name: "setting",
  initialState,
  reducers: {
    setDynamicColor(state, action) {
      state.dynamicColor = action.payload;
    },
  },
});

export const { setDynamicColor } = settingsSlice.actions;

export default settingsSlice.reducer;
